module.exports = __webpack_public_path__ + "img/img_logo.601d8511.png";